import { __assign } from "tslib";
import * as React from 'react';
import { ActionsCtx } from '../components/solution-page/actions-context/ActionCtx';
export var withPermissions = function (component) {
    return function (props) {
        return (React.createElement(ActionsCtx.Consumer, null, function (permissions) {
            return React.createElement(component, __assign(__assign({}, props), { permissions: permissions }));
        }));
    };
};
//# sourceMappingURL=with-market-permissions.js.map